import React from 'react';

import Shipments from '../../../assets/media/home-page/icons/Shipments.png';
import Carriers from '../../../assets/media/home-page/icons/Carriers.png';
import Tons_Dispatches from '../../../assets/media/home-page/icons/Tons-Dispatches.png';
import Registered_Users from '../../../assets/media/home-page/icons/registered-Users.png';
import TittleWithAnimation from './TittleWithAnimation';
import our_Stats_Truck from '../../../assets/media/home-page/OurStatsTruck.jpg'

import gsap from 'gsap'
import { Tween } from 'react-gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


const OurState = () => {
    return (
        <section id="our-state">
            <div className="container">
                <h1 className="our-state-tittle">
                    <i className="fa-solid fa-users"></i>

                    <TittleWithAnimation
                        word="Our Stats"
                        _trigger="#our-state"
                    />
                </h1>

                <Tween
                    to={{
                        scrollTrigger: {
                            trigger: "#our-state",
                            start: "center center",
                            // markers: true
                        },
                        css: {
                            opacity : 1,
                            x: 0
                        }
                    }}
                >
                    <div className="our-stats-card-area">
                            <div className="our-stats-double-card">
                                <Stats_Card
                                    name = 'Shipments'
                                    value = '123'
                                    img = {Shipments}
                                />

                                <Stats_Card
                                    name = 'Carriers'
                                    value = '123'
                                    img = {Carriers}
                                />
                            </div>

                            <div className="our-stats-double-card">
                                <Stats_Card
                                    name = 'Tons Dispatches'
                                    value = '123'
                                    img = {Tons_Dispatches}
                                />

                                <Stats_Card
                                    name = 'Registered Users'
                                    value = '123'
                                    img = {Registered_Users}
                                />
                                
                            </div>

                    </div>
                </Tween>

            </div>

            <Tween
                to={{
                    scrollTrigger: {
                        trigger: "#our-state",
                        start: "-100px bottom",
                        end : 'center center',
                        scrub: 0.5,
                        // markers: true
                    },
                    css: {
                        top : 0,
                        opacity : 1
                    }
                }}
            >
                <div className="our-site-bg">
                    <img src={our_Stats_Truck} alt="our_Stats_Truck"/>
                </div>
            </Tween>

        </section>
    )
}

export default OurState;





const Stats_Card = ({value, img, name}) =>(
    <div className="our-stats-card">
        <div>
            <span>{value}</span>
            <div className="our-stats-tittle-icon">
                <img src={img} alt={name}/>
                <p>{name}</p>
            </div>
        </div>
    </div>
);
